import React from 'react'
import CartItems from '../Components/CartItems/CartItems'

const Cart = () => {
  return (
    <div>
      <CartItems/>
      <div className="apple-pay-wrapper">
      <button className="apple-pay-button">
      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Apple_Pay_logo.svg/1024px-Apple_Pay_logo.svg.png" alt="Apple Pay" />
      </button>
    </div>
    </div>
    
  )
}

export default Cart


